import React from "react";
import { Layout } from "antd";
import { useLocation } from "react-router-dom";
import Header from "../common/Header";
import Footer from "../common/Footer";

const { Content } = Layout;
function Main({ children }: any) {
    const location = useLocation();
    return (

        <Layout style={{ overflow: location.pathname.startsWith("/Ido/FullSearchProject") ? 'visible' : 'hidden' }}>
            <Header />
            <Content>{children}</Content>
            <Footer />
        </Layout>
    );
}

export default Main;
